import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';

type Props = {
  active?: boolean;
  onClick?: () => void;
};

const EyeIconButton = ({ active, onClick }: Props): ReactNode => {
  const { t } = useTranslation();

  return (
    <Tooltip placement="top" title={active ? t('hide') : t('display')}>
      <Button
        type="text"
        shape="circle"
        icon={
          active ? (
            <FontAwesomeIcon icon={faEye} color="var(--primary-color)" />
          ) : (
            <FontAwesomeIcon icon={faEyeSlash} color="#D2D2D2" />
          )
        }
        onClick={(event) => {
          event.stopPropagation();
          onClick?.();
        }}
      />
    </Tooltip>
  );
};

export { EyeIconButton };
